import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosCall, AxiosPost } from '../../../utils/axios';
import * as actions from './labelActions';

// Get Label Brands
function* getLabelBrands() {
  try {
    const result = yield call(AxiosCall, '/mycore/labels/brands/');
    yield put(actions.getLabelBrandsSuccess(result.data));
  } catch (e) {
    yield put(actions.getLabelBrandsFailure(e.response?.data?.error || e.message));
  }
}

// Get Label Sizes
function* getLabelSizes(action) {
  try {
    const params = action.payload || {};
    let url = '/mycore/labels/sizes/';

    // Build query string
    const queryParams = [];
    if (params.brand) queryParams.push(`brand=${params.brand}`);
    if (params.category) queryParams.push(`category=${params.category}`);
    if (params.organization) queryParams.push(`organization=${params.organization}`);

    if (queryParams.length > 0) {
      url += `?${queryParams.join('&')}`;
    }

    const result = yield call(AxiosCall, url);
    yield put(actions.getLabelSizesSuccess(result.data));
  } catch (e) {
    yield put(actions.getLabelSizesFailure(e.response?.data?.error || e.message));
  }
}

// Get Label Size (single)
function* getLabelSize(action) {
  try {
    const id = action.payload;
    const result = yield call(AxiosCall, `/mycore/${id}/labels/size/`);
    yield put(actions.getLabelSizeSuccess(result.data));
  } catch (e) {
    yield put(actions.getLabelSizeFailure(e.response?.data?.error || e.message));
  }
}

// Create Label Size
function* createLabelSize(action) {
  try {
    const result = yield call(AxiosPost, '/mycore/labels/sizes/create/', action.payload);
    yield put(actions.createLabelSizeSuccess(result.data));
  } catch (e) {
    yield put(actions.createLabelSizeFailure(e.response?.data?.error || e.message));
  }
}

// Get Batch Label Data
function* getBatchLabelData(action) {
  try {
    const batchId = action.payload;
    const result = yield call(AxiosCall, `/mycore/${batchId}/labels/batch-data/`);
    yield put(actions.getBatchLabelDataSuccess(result.data));
  } catch (e) {
    yield put(actions.getBatchLabelDataFailure(e.response?.data?.error || e.message));
  }
}

// Get Spawn Source Label Data
function* getSpawnSourceLabelData(action) {
  try {
    const spawnSourceId = action.payload;
    const result = yield call(AxiosCall, `/mycore/${spawnSourceId}/labels/spawn-source-data/`);
    yield put(actions.getSpawnSourceLabelDataSuccess(result.data));
  } catch (e) {
    yield put(actions.getSpawnSourceLabelDataFailure(e.response?.data?.error || e.message));
  }
}

// Get Label Fields Config
function* getLabelFieldsConfig() {
  try {
    const result = yield call(AxiosCall, '/mycore/labels/fields-config/');
    yield put(actions.getLabelFieldsConfigSuccess(result.data));
  } catch (e) {
    yield put(actions.getLabelFieldsConfigFailure(e.response?.data?.error || e.message));
  }
}

// Get Label Categories
function* getLabelCategories() {
  try {
    const result = yield call(AxiosCall, '/mycore/labels/categories/');
    yield put(actions.getLabelCategoriesSuccess(result.data));
  } catch (e) {
    yield put(actions.getLabelCategoriesFailure(e.response?.data?.error || e.message));
  }
}

// Root Saga
export default function* labelSaga() {
  yield all([
    takeLatest(actions.GET_LABEL_BRANDS.REQUEST, getLabelBrands),
    takeLatest(actions.GET_LABEL_SIZES.REQUEST, getLabelSizes),
    takeLatest(actions.GET_LABEL_SIZE.REQUEST, getLabelSize),
    takeLatest(actions.CREATE_LABEL_SIZE.REQUEST, createLabelSize),
    takeLatest(actions.GET_BATCH_LABEL_DATA.REQUEST, getBatchLabelData),
    takeLatest(actions.GET_SPAWN_SOURCE_LABEL_DATA.REQUEST, getSpawnSourceLabelData),
    takeLatest(actions.GET_LABEL_FIELDS_CONFIG.REQUEST, getLabelFieldsConfig),
    takeLatest(actions.GET_LABEL_CATEGORIES.REQUEST, getLabelCategories),
  ]);
}
